import prettier from 'prettier/standalone';
import parserBabel from 'prettier/parser-babel';
import sqlPrettier from 'sql-prettier';
import parserHtml from 'prettier/parser-html';
import { DATA_TYPES } from '../constants';
const { HTML, SQL, JAVASCRIPT, JSON_MODE, TEXT } = DATA_TYPES

const getFormattedCode = (mode, inputData) => {
    let formattedCode;

    switch (mode) {
        case SQL:
            formattedCode = sqlPrettier.format(inputData);
            break;
        case JSON_MODE:
            formattedCode = prettier.format(inputData, {
                parser: 'json',
                plugins: [parserBabel],
            });
            break;
        case JAVASCRIPT:
            formattedCode = prettier.format(inputData, {
                parser: 'babel',
                plugins: [parserBabel],
            });
            break;
        case HTML:
            formattedCode = prettier.format(inputData, {
                parser: 'html',
                plugins: [parserHtml],
            });
            break;
        case TEXT:
            formattedCode = inputData;
            break;
        default:
            console.error('Unknown mode:', mode);
    }
    return formattedCode;
};
export default getFormattedCode;
